import { Box, CircularProgress, Typography } from "@mui/material";

import styles from "./styles";

export type GenBrandStatus = "pending" | "generating" | "done" | "failed";

export interface GenBrand {
  name: string;
  status: GenBrandStatus;
}

interface Props {
  total: number;
  done: number;
  brands: GenBrand[];
}

export default function Generating({ total, done, brands }: Props) {
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  return (
    <Box sx={styles.genWrap}>
      <Box sx={styles.genSpark}>
        <Box component="i" className="fa-solid fa-sparkles" />
      </Box>
      <Typography sx={styles.genHeading}>
        Drafting {total} personalized pitches…
      </Typography>
      <Typography sx={styles.genSub}>
        Bento is tailoring each email to the brand. This can take a few minutes.
      </Typography>
      <Box sx={styles.genBar}>
        <Box sx={styles.genBarFill(pct)} />
      </Box>
      <Typography sx={styles.genCount}>
        {done} of {total} drafted
      </Typography>
      {brands.length > 0 && (
        <Box sx={styles.genList}>
          {brands.map((brand, index) => (
            <Box key={`${brand.name}-${index}`} sx={styles.genItem}>
              <Box sx={styles.genItemDot(brand.status)}>
                {brand.status === "done" && (
                  <Box component="i" className="fa-solid fa-check" />
                )}
                {brand.status === "generating" && (
                  <CircularProgress size={16} thickness={5} color="inherit" />
                )}
              </Box>
              <Typography sx={styles.genItemText(brand.status)}>
                {brand.status === "done" && (
                  <>
                    Personalized pitch for <strong>{brand.name}</strong>
                  </>
                )}
                {brand.status === "generating" && (
                  <>
                    Writing pitch for <strong>{brand.name}</strong> …
                  </>
                )}
                {(brand.status === "pending" || brand.status === "failed") && (
                  <strong>{brand.name}</strong>
                )}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
